import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  GET_PATIENT_INFO_V2_DAILY_SESSION_REQUEST,
  GET_PATIENT_INFO_V2_DAILY_SESSION_SUCCESS,
  GET_PATIENT_INFO_V2_DAILY_SESSION_FAILURE,
  GET_PATIENT_INFO_V2_DAILY_SESSION_LOADING,
} = dailySessionNotes;

function* getPatientInfoV2(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PATIENT_INFO_V2_DAILY_SESSION_LOADING });

    const response = yield call(dailySessionNotesService.getTherapyInfoV2, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_INFO_V2_DAILY_SESSION_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_INFO_V2_DAILY_SESSION_FAILURE, payload: error });
  }
}

function* getPatientInfoV2Saga() {
  yield takeEvery(GET_PATIENT_INFO_V2_DAILY_SESSION_REQUEST, getPatientInfoV2);
}

export default getPatientInfoV2Saga;
